import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

export default {
    updateRfqSubscribers: (rfqUniquePublicId: string, userIds: number[]) =>
        fetch(`${PURCHASER_API_BASE_URL}/v2/rfqs/${rfqUniquePublicId}/subscriptions`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify({ userIds }),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Error updating RFQ subscriptions");
            }
            return res.json();
        }),
    deleteRfqSubscribers: (rfqUniquePublicId: string, userIds: number[]) =>
        fetch(`${PURCHASER_API_BASE_URL}/v2/rfqs/${rfqUniquePublicId}/subscriptions`, {
            method: "DELETE",
            headers: getHeaders(),
            body: JSON.stringify({ userIds }),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Error deleting RFQ subscriptions");
            }
            return res.json();
        }),
};
